import {
  FETCH_INSIGHTS_SUMMARY,
  FETCH_INSIGHTS_FOOTFALL,
  FETCH_DAILY_AVERAGES,
  FETCH_INSIGHTS_POI_COUNT,
  FETCH_INSIGHTS_FOOTFALL_OVER_TIME,
  SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT,
  FETCH_INSIGHTS_FOOTFALL_PERCENTAGE,
  FETCH_INSIGHTS_REPEAT_VS_UNIQUE,
  SELECT_INSIGHTS_TIME_PERIOD,
  DOWNLOAD_AUDIENCE,
} from '../constants';

export const fetchInsightsSummary = () => ({type: FETCH_INSIGHTS_SUMMARY});
export const fetchInsightsFootfall = () => ({type: FETCH_INSIGHTS_FOOTFALL});
export const fetchDailyAverages = () => ({type: FETCH_DAILY_AVERAGES});
export const fetchInsightsFootfallOverTime = () => ({type: FETCH_INSIGHTS_FOOTFALL_OVER_TIME});
export const setFootFallOverTimeUnit = unit => ({
  type: SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT,
  unit
});
export const fetchInsightsFootfallPercentage = () => ({type: FETCH_INSIGHTS_FOOTFALL_PERCENTAGE});
export const fetchInsightsRepeatVsUnique = () =>({type: FETCH_INSIGHTS_REPEAT_VS_UNIQUE});
export const selectFootfallTimePeriod = selectedPeriod =>({
  type: SELECT_INSIGHTS_TIME_PERIOD,
  selectedPeriod,
});

export const fetchInsightsPoiCount = () =>({type: FETCH_INSIGHTS_POI_COUNT});
export const downloadAudience = (csvType, reportType, fileName) => ({
  type: DOWNLOAD_AUDIENCE,
  csvType,
  reportType,
  fileName
});
